import React from "react";
import useTabTitle from "../hooks/useTabTitle";
import { ContentContainer } from "./Abonnement";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useIsLoggedIn } from "../hooks/auth";
import { CheckCircleRounded } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import InexCard from "../components/InexCard";
import InexButton from "../components/InexButton";

const DonationSuccess = () => {
	useTabTitle({ customTitle: "Donations effectuée avec succès !" });
	const navigate = useNavigate();
	const isLoggedIn = useIsLoggedIn();

	const { montant } = useParams();

	if (montant == null) {
		navigate(isLoggedIn ? "/profil" : "/faq");
	}

	return (
		<ContentContainer container item className={"content-background"}>
			<InexCard>
				<Grid container flexDirection={"column"}>
					<Grid
						item
						xs={12}
						container
						flexDirection={"row"}
						alignItems={"center"}
						justifyContent={"center"}
						spacing={2}
					>
						<Grid item xs={12} alignItems={"center"} justifyContent={"center"}>
							<CheckCircleRounded
								color={"success"}
								sx={{
									width: "50px",
									height: "50px",
								}}
							/>
						</Grid>
						<Grid item flexDirection={"column"} xs={12}>
							<Typography
								variant={"h5"}
								sx={{
									fontFamily: "Branding Bold",
								}}
							>
								{`MERCI`}
							</Typography>
							<Typography
								variant={"h6"}
								sx={{
									fontFamily: "Branding SemiBold",
								}}
							>
								{`Votre donation de ${(montant / 100).toFixed(2)}€ est validée`}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={12} pt={3}>
						<InexButton
							text={"Retourner à mon profil"}
							sx={{
								width: "100%",
							}}
							onClick={() => {
								navigate("/profil");
							}}
						/>
					</Grid>
				</Grid>
			</InexCard>
		</ContentContainer>
	);
};

export default DonationSuccess;
